/*
 * Seed Jewelry — mobile tap-to-swap for transformable pieces (27 Aug 2026, Rodion feedback via Jon)
 * Extended 27 Aug 2026 to also cover homepage product cards.
 *
 * First tap on a tap-swap-enabled card image toggles the secondary ("transformed") image into
 * view instead of navigating — matching each card type's own desktop hover swap. Navigation to
 * the product page still happens via the title/price link elsewhere on the card.
 *
 * Two card markups are supported (see seed-transformable-tap.css for the full explanation):
 *   - snippets/product-card.liquid: the tap-swap class (`.product-card__media--tap-swap`) sits
 *     directly on the clickable media link, and that same element gets `.is-swapped` toggled.
 *   - snippets/seed-product-card.liquid: the tap-swap class (`.seed-card--tap-swap`) sits on the
 *     outer card wrapper; the clickable media link is a child (`.seed-card__media`), and
 *     `.is-swapped` is toggled on the wrapper, not the link.
 *
 * Only intercepts on coarse/no-pointer (touch) devices. Fine-pointer devices (mouse) are left
 * alone entirely and keep normal link navigation plus each card's existing hover swap.
 */
(function () {
  if (window.__seedTapSwapBound) return;
  window.__seedTapSwapBound = true;

  document.addEventListener(
    'click',
    function (event) {
      var mediaLink = event.target.closest(
        '.product-card__media--tap-swap, .seed-card--tap-swap > .seed-card__media'
      );
      if (!mediaLink) return;
      if (window.matchMedia('(pointer: fine)').matches) return;

      event.preventDefault();

      var swapRoot = mediaLink.classList.contains('product-card__media--tap-swap')
        ? mediaLink
        : mediaLink.closest('.seed-card--tap-swap');

      if (swapRoot) swapRoot.classList.toggle('is-swapped');
    },
    true
  );
})();
